module.exports = __webpack_public_path__ + "static/media/women-fas-cat-4.3ca4f013.png";